const BackgroundStripes = () => {
  return (
    <div className="bw-absolute bw-inset-0 bw-overflow-hidden bw-pointer-events-none">
      {/* Angled stripes coming from top-left, stopping randomly */}
      <div className="bw-absolute bw--top-32 bw--left-32 bw-w-96 bw-h-96 bw-bg-gradient-to-br bw-from-primary/10 bw-to-transparent bw-transform bw-rotate-45 bw-animate-pulse"></div>

      <div className="bw-absolute bw-top-20 bw--left-20 bw-w-80 bw-h-80 bw-bg-gradient-to-br bw-from-secondary/8 bw-to-transparent bw-transform bw-rotate-45 animation-delay-1000 bw-animate-pulse"></div>

      <div className="bw-absolute bw-top-40 bw-left-10 bw-w-64 bw-h-64 bw-bg-gradient-to-br bw-from-accent/12 bw-to-transparent bw-transform bw-rotate-45 animation-delay-2000 bw-animate-pulse"></div>

      <div className="bw-absolute bw-top-60 bw-left-40 bw-w-48 bw-h-48 bw-bg-gradient-to-br bw-from-primary/6 bw-to-transparent bw-transform bw-rotate-45 animation-delay-3000 bw-animate-pulse"></div>

      <div className="bw-absolute bw-top-80 bw-left-80 bw-w-32 bw-h-32 bw-bg-gradient-to-br bw-from-secondary/10 bw-to-transparent bw-transform bw-rotate-45 animation-delay-4000 bw-animate-pulse"></div>
    </div>
  );
};

export default BackgroundStripes;
